import { Command } from 'commander'
import { createClient } from '../../../client.js'
import { handleError } from '../../../lib/errors.js'
import {
  isQuiet,
  printQuiet,
  printJson,
  printSuccess,
  printKeyValue,
} from '../../../output.js'

export const servicesCreateProxyCommand = new Command(`proxy`)
  .usage(`--environment <id> --name <name> --allowlist <patterns>`)
  .description(`Create a proxy service`)
  .requiredOption(`--environment <id>`, `Environment ID`)
  .requiredOption(`--name <name>`, `Service name`)
  .requiredOption(`--allowlist <patterns>`, `Comma-separated URL patterns`)
  .action(async (opts) => {
    const json =
      servicesCreateProxyCommand.parent?.parent?.parent?.opts().json ?? false
    try {
      const allowlist = (opts.allowlist as string)
        .split(`,`)
        .map((s: string) => s.trim())

      const client = createClient()
      const result = await client.services.proxy.create({
        environmentId: opts.environment,
        name: opts.name,
        allowlist,
      })

      if (isQuiet()) {
        printQuiet(result.id)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Service created successfully.\n`)
        printKeyValue([
          [`ID:`, result.id],
          [`Name:`, result.name],
          [`Base URL:`, result.baseUrl],
          [`Secret:`, result.secret],
        ])
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
